export enum RbacRoleGremlinInternal {
  ADMIN = 'ADMIN',
  DEV = 'DEV',
  BOOTCAMP_ORGANIZER = 'BOOTCAMP_ORGANIZER'
}

export enum RbacRoleCompany {
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  COMPANY_COORDINATOR = 'COMPANY_COORDINATOR',
  COMPANY_MANAGER = 'COMPANY_MANAGER',
  COMPANY_OWNER = 'COMPANY_OWNER',
  COMPANY_USER = 'COMPANY_USER'
}

export enum RbacRoleTeam {
  TEAM_CREDENTIAL_MANAGER = 'TEAM_CREDENTIAL_MANAGER',
  TEAM_MANAGER = 'TEAM_MANAGER',
  TEAM_USER = 'TEAM_USER',
  TEAM_VIEWER = 'TEAM_VIEWER'
}

export type RbacRolesAll =
  | RbacRoleGremlinInternal
  | RbacRoleCompany
  | RbacRoleTeam

export enum RbacPrivilege {
  // Company
  ACCESS_SECURITY_LOGS = 'ACCESS_SECURITY_LOGS',
  ACTIVATE_USER = 'ACTIVATE_USER',
  ADD_USER_TO_COMPANY = 'ADD_USER_TO_COMPANY',
  ADD_USER_TO_COMPANY_WITHOUT_INVITE = 'ADD_USER_TO_COMPANY_WITHOUT_INVITE',
  COMPANY_DEFAULT = 'COMPANY_DEFAULT',
  CREATE_REMOVE_TEAM = 'CREATE_REMOVE_TEAM',
  DEACTIVATE_USER = 'DEACTIVATE_USER',
  MANAGE_COMPANY_PREFS = 'MANAGE_COMPANY_PREFS',
  MANAGE_COMPANY_USER_PERMISSIONS = 'MANAGE_COMPANY_USER_PERMISSIONS',
  MANAGE_INTEGRATIONS = 'MANAGE_INTEGRATIONS',
  MANAGE_MFA = 'MANAGE_MFA',
  MANAGE_OAUTH = 'MANAGE_OAUTH',
  MANAGE_SAML = 'MANAGE_SAML',
  MANAGE_TEST_SUITES = 'MANAGE_TEST_SUITES',
  PROMOTE_DEMOTE_OWNER = 'PROMOTE_DEMOTE_OWNER',
  READ_ALL_API_KEYS = 'READ_ALL_API_KEYS',
  READ_ALL_CLIENTS = 'READ_ALL_CLIENTS',
  READ_ALL_INTEGRATION_CLIENTS = 'READ_ALL_INTEGRATION_CLIENTS',
  READ_ALL_USERS = 'READ_ALL_USERS',
  READ_COMPANY_RM_REPORTS = 'READ_COMPANY_RM_REPORTS',
  UNSHARE_SCENARIO = 'UNSHARE_SCENARIO',

  // Team
  ACTIVATE_API_KEY = 'ACTIVATE_API_KEY',
  ACTIVATE_CLIENT = 'ACTIVATE_CLIENT',
  ADD_REMOVE_USER_FROM_TEAM = 'ADD_REMOVE_USER_FROM_TEAM',
  MANAGE_MONITORING_FOR_TEAM = 'MANAGE_MONITORING_FOR_TEAM',
  MANAGE_NOTIFICATION_SETTINGS_FOR_TEAM = 'MANAGE_NOTIFICATION_SETTINGS_FOR_TEAM',
  MANAGE_TEAM_CREDENTIALS = 'MANAGE_TEAM_CREDENTIALS',
  MANAGE_TEAM_DETAILS = 'MANAGE_TEAM_DETAILS',
  MANAGE_TEAM_USER_PERMISSIONS = 'MANAGE_TEAM_USER_PERMISSIONS',
  MANAGE_WEBHOOKS = 'MANAGE_WEBHOOKS',
  READ_TEAM_ATTACKS = 'READ_TEAM_ATTACKS',
  READ_TEAM_CLIENTS = 'READ_TEAM_CLIENTS',
  READ_TEAM_SCENARIOS = 'READ_TEAM_SCENARIOS',
  READ_TEAM_SCHEDULES = 'READ_TEAM_SCHEDULES',
  READ_TEAM_USERS = 'READ_TEAM_USERS',
  SHARE_ASSET = 'SHARE_ASSET',
  SHARE_SCENARIO = 'SHARE_SCENARIO',
  TEAM_DEFAULT = 'TEAM_DEFAULT'
}

export interface RbacRoleCompanyItem {
  key: RbacRoleCompany | RbacRoleGremlinInternal
  description: string
  privileges: RbacPrivilege[]
}

export interface RbacRoleTeamItem {
  key: RbacRoleTeam
  description: string
  privileges: RbacPrivilege[]
}

export interface RbacPrivilegeItem {
  key: RbacPrivilege
  description: string
}

export interface RbacBody {
  roles: {
    company: Partial<
      Record<RbacRoleCompany | RbacRoleGremlinInternal, RbacRoleCompanyItem>
    >
    team: Record<RbacRoleTeam, RbacRoleTeamItem>
  }
  privileges: {
    company: Partial<Record<RbacPrivilege, RbacPrivilegeItem>>
    team: Partial<Record<RbacPrivilege, RbacPrivilegeItem>>
  }
}
